export const billboardTheme = colors => ({
  babies: {
    color: colors.babies[900],
    colorHover: colors.babies[800],
    background: colors.babies[100]
  },
  babies_dark: {
    color: colors.babies[900],
    colorHover: colors.babies[800],
    background: colors.babies[300]
  },
  kids: {
    color: colors.kids[900],
    colorHover: colors.kids[800],
    background: colors.kids[100]
  },
  kids_dark: {
    color: colors.kids[900],
    colorHover: colors.kids[800],
    background: colors.kids[300]
  },
  tweens: {
    color: colors.tweens[900],
    colorHover: colors.tweens[800],
    background: colors.tweens[100]
  },
  tweens_dark: {
    color: colors.tweens[900],
    colorHover: colors.tweens[800],
    background: colors.tweens[300]
  },
  teens: {
    color: colors.teens[900],
    colorHover: colors.teens[800],
    background: colors.teens[100]
  },
  teens_dark: {
    color: colors.teens[900],
    colorHover: colors.teens[800],
    background: colors.teens[300]
  },
  white: {
    color: colors.neutral[900],
    colorHover: colors.neutral[800],
    background: colors.neutral[100]
  },
  neutral: {
    color: colors.neutral[900],
    colorHover: colors.neutral[800],
    background: colors.neutral[200]
  },
  neutral_dark: {
    background: colors.neutral[900],
    clickable: colors.primary[600],
    hover: colors.primary[100],
    icon: colors.neutral[900],
    saturated: colors.neutral[200],
    secondary: colors.neutral[900],
    secondaryHover: colors.neutral[800],
    text: colors.neutral[100],
    color: colors.neutral[100]
  },
  franchises_dark: {
    color: colors.neutral?.[100],
    colorHover: colors.franquicias?.[100],
    background: colors.neutral?.[800],
    bar: colors.franquicias?.[100]
  },
  franchises_light: {
    color: colors.franquicias?.[800],
    colorHover: colors.franquicias?.[500],
    background: colors.franquicias?.[100],
    bar: colors.franquicias?.[300]
  }
});
